import React from 'react';
import HomePage from "../src/pages/home";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AboutPage from "./pages/about";
import ServicePage from "./pages/services";
import WorkPage from "./pages/work";
import ContactPage from "./pages/contact";
import PoolPage from "./pages/product/pool";
import AuditraPage from "./pages/product/auditra";
import TermsPage from "./pages/legal/terms";
import PrivacyPage from "./pages/legal/privacy";
import BlogPost from "./pages/blog/BlogPost";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/products/pool" element={<PoolPage />} />
        <Route path="/products/auditra" element={<AuditraPage />} />
        {/* Old combined product page; keep the URL working */}
        <Route path="/product" element={<Navigate to="/products/pool" replace />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </Router>
  );
};

export default App;
